import { morphism } from 'morphism'

import errorDataSchema from './errorData'

import ErrorDataModel from '../models/ErrorData'

/**
 * Transform the extra data attributes of a error
 * in the correct schema.
 *
 * @param {Object} error
 */
const errorData = ({ data = {} }) => {
  const hasData = Object.keys(data).length

  return hasData ? morphism(errorDataSchema, data, ErrorDataModel) : null
}

export default {
  message: 'message',
  code: 'code',
  data: errorData,
  // ItemId is needed for flightPassengersDelete
  itemId: 'itemId',
}
